// dependencies
import { CreateProcess } from "redux-process";

// utils
import get from "../../utils/GetNested";

export const getReviewForms = CreateProcess({
	method: "POST",
	name: "getReviewForms",
	type: "REVIEW_FORMS:FETCH",

	request: (props) => {
		const payload = get(props, ["params", "payload"], props.payload);

		return {
			url: `/micro/v0.1/review-form-picker`,
			payload,
		};
	},

	success: (response) => response.data,
});
